import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

export interface ItemListFilterState {
  /** フィルタ設定のMAP（key：コンポーネント名、value：設定情報） */
  filterMap: { [key: string]: any };
  /** ページング設定のMAP（key：コンポーネント名、value：設定情報） */
  currentPageMap: { [key: string]: any };
  /** 履歴範囲設定のMAP（key：コンポーネント名、value：設定情報） */
  historyPeriodMap: { [key: string]: any };
}

@Module({ name: "itemListFilter" })
export default class ItemListFilter extends VuexModule implements ItemListFilterState {
  /** フィルタ設定のMAP */
  filterMap: { [key: string]: any } = {};
  /** ページング設定のMAP */
  currentPageMap: { [key: string]: any } = {};
  /** 履歴範囲設定のMAP */
  historyPeriodMap: { [key: string]: any } = {};

  /** 初期化 */
  @Mutation
  private INITIALIZE_STATE(): void {
    this.filterMap = {};
    this.currentPageMap = {};
    this.historyPeriodMap = {};
    return;
  }

  /** 初期化を呼び出す */
  @Action({ rawError: true })
  public initializeState(): void {
    this.INITIALIZE_STATE();
    return;
  }

  /** 初期化 */
  @Mutation
  private INITIALIZE_STATE_FOR_URL(url: string): void {
    delete this.filterMap[url];
    delete this.currentPageMap[url];
    delete this.historyPeriodMap[url];
    return;
  }

  /** 初期化を呼び出す */
  @Action({ rawError: true })
  public initializeStateForUrl(params: { url: string }): void {
    this.INITIALIZE_STATE_FOR_URL(params.url);
    return;
  }

  /** フィルタ情報の設定 */
  @Mutation
  private SET_FILTER(params: { url: string; filter: any }): void {
    this.filterMap[params.url] = params.filter;
    return;
  }

  /** フィルタ情報の設定を呼び出す */
  @Action({ rawError: true })
  public setFilter(payload: { url: string; filter: any }): void {
    this.SET_FILTER(payload);
    return;
  }

  /** ページング情報の設定 */
  @Mutation
  private SET_CURRENT_PAGE(params: { url: string; currentPage: number }): void {
    this.currentPageMap[params.url] = params.currentPage;
    return;
  }

  /** ページング情報の設定を呼び出す */
  @Action({ rawError: true })
  public setCurrentPage(payload: { url: string; currentPage: number }): void {
    this.SET_CURRENT_PAGE(payload);
    return;
  }

  /** 履歴範囲情報の設定 */
  @Mutation
  private SET_HISTORY_PERIOD(params: { url: string; historyPeriod: number }): void {
    this.historyPeriodMap[params.url] = params.historyPeriod;
    return;
  }

  /** 履歴範囲情報の設定を呼び出す */
  @Action({ rawError: true })
  public setHistoryPeriod(payload: { url: string; historyPeriod: number }): void {
    this.SET_HISTORY_PERIOD(payload);
    return;
  }
}
